(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loyalty-section"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.loyalty-section')
    const prevButton = section.querySelector('.loyalty-section__nav-button:first-of-type')
    const nextButton = section.querySelector('.loyalty-section__nav-button:last-of-type')
    const steps = section.querySelectorAll('.loyalty-section__step')

    let currentStep = 0

    prevButton.addEventListener('click', () => {
      currentStep = currentStep === 0 ? steps.length - 1 : currentStep - 1

      updateStep()
    })

    nextButton.addEventListener('click', () => {
      currentStep = currentStep === steps.length - 1 ? 0 : currentStep + 1

      updateStep()
    })

    function updateStep() {
      steps.forEach((step, index) => {
        step.classList.toggle('is-active', index === currentStep)
      })
    }
  })

  } catch(e) { console.error(e); }
})();
})();
